//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom, map, of } from 'rxjs';
import { TypeCompanyFileDTO } from 'src/app/core/models/system/type/type-company-file.dto';

@Injectable({ providedIn: 'root' })

export class TypesCompanyFileService {
  
  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeCompanyFileDTO[]>(environment.eSimApi + eSimApiPaths.TypesCompanyFile)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(typeCompanyFile: TypeCompanyFileDTO) {
    return {id: typeCompanyFile.id, description: typeCompanyFile.companyFileType};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
